"use strict";

($dt => {
	
	$dt.TopicGrid.Functions = {
		...$dt.TopicGrid.Functions,
		
		/**
		 * Called once on load to retrieve things already known about the user such as whether or not they are logged in
		 * @param {Block} block 
		 */
		InitSession: (block, onComplete) => {
			const nonceReady = (nonce) => {
				const xhr = new XMLHttpRequest();
				xhr.open('POST', $dt.ajax_url);
				xhr.withCredentials = true;
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
				xhr.onload = () => {
					if (xhr.status === 200) {
						const resp = JSON.parse(xhr.responseText);

						// Info collected
						const { contact_info } = block;
						contact_info.anon = resp.anon;
						contact_info.school_name = resp.school_name;

						if (!contact_info.anon) {
							contact_info.firstname = resp.firstname;
							contact_info.lastname = resp.lastname;
							contact_info.street_address1 = resp.street1;
							contact_info.city = resp.city;
							contact_info.state = resp.state;
							contact_info.zip = resp.zip;
						}

						block.todays_date = new Date(resp.todays_date);

						// Session loaded
						onComplete();
					}
				};
				xhr.send('action=dcube_edupgrams_getuserinfo&nonce=' + encodeURIComponent(nonce));
			};

			$dt.OnDevelformsReady($df => {
				$df.RegisterValidatedEvent(nonceReady);
			});
		}
	};

})(window.d3_wp_themejs);
